import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import he from './translations/he/global.json';
import ar from './translations/ar/global.json';
import en from './translations/en/global.json';

export type SupportedLanguage = 'he' | 'ar' | 'en';

export const STORAGE_KEY_LANG = 'haat_partner_connect_lang';

const isSupportedLanguage = (value: string | null): value is SupportedLanguage =>
  value === 'he' || value === 'ar' || value === 'en';

const stored = typeof window !== 'undefined' ? localStorage.getItem(STORAGE_KEY_LANG) : null;
const initialLng: SupportedLanguage = isSupportedLanguage(stored) ? stored : 'he';

i18n.use(initReactI18next).init({
  resources: {
    he: { global: he },
    ar: { global: ar },
    en: { global: en },
  },
  lng: initialLng,
  fallbackLng: 'en',
  defaultNS: 'global',
  ns: ['global'],
  interpolation: { escapeValue: false },
});

export default i18n;
